import { GeneratePresignedUploadUrlResponseBody, GeneratePresignedUploadUrlRequestBody } from '@boltenergy-be/shared'
import { NextApiResponseBody } from 'types/bolt-api/request'
import { isValidMimeType } from './utils'

export const uploadPresigned = async (file: File): Promise<NextApiResponseBody<string>> => {
  try {
    if (!isValidMimeType(file.type)) {
      throw new Error(`File type ${file.type} is not allowed for upload`)
    }

    // Generate presigned request body
    const presignedRequestBody: GeneratePresignedUploadUrlRequestBody = {
      contentType: file.type,
      contentLength: file.size
    }

    // Generate presigned url and key for current file
    const presignedUrlsRes = await fetch(`/api/utilities/files/uploads/presign`, {
      method: 'POST',
      body: JSON.stringify(presignedRequestBody)
    })
    const { success, data } = (await presignedUrlsRes.json()) as NextApiResponseBody<GeneratePresignedUploadUrlResponseBody>

    if (!success || !data?.uploadUrl || !data?.key) {
      return { success: false }
    }

    // Upload the file to the received S3 upload url
    const uploadRes = await fetch(data.uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file
    })

    return {
      success: !!uploadRes?.ok,
      data: data.key
    }
  } catch (error) {
    return { success: false }
  }
}
